import { Check, X } from "lucide-react";

const YES = ["Which AI service or agent, and the company behind it", "Direction: used from inside, or reaching in", "Which network area, using names you choose", "Arrival time and whether its origin checked out", "Signs of agents hiding their identity"];
const NO = ["Which device, guest or employee (never identified)", "IP or hardware (MAC) addresses: checked on the device, never sent", "Message content, cookies, logins or form data", "Web addresses beyond the AI service name"];

const List = ({ items, ok }) => (
  <ul className="space-y-3">
    {items.map((t) => (
      <li key={t} className="flex gap-3 text-sm text-slate-300">
        {ok ? <Check className="h-4 w-4 text-emerald-400 mt-0.5 shrink-0" /> : <X className="h-4 w-4 text-rose-400 mt-0.5 shrink-0" />}{t}
      </li>
    ))}
  </ul>
);

export const Recorded = () => (
  <section id="privacy" className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-24 scroll-mt-16" data-testid="landing-privacy">
    <p className="font-mono text-xs text-emerald-400 tracking-[0.3em] uppercase">What we record</p>
    <h2 className="text-2xl sm:text-3xl font-semibold text-slate-50 mt-3 max-w-2xl">The agent's ID card, and nothing about your guests.</h2>
    <div className="grid md:grid-cols-2 gap-6 mt-14">
      <div className="rounded-md border border-emerald-500/25 bg-[#141A24] p-6">
        <h3 className="text-sm font-semibold text-emerald-300 mb-5">Recorded</h3>
        <List items={YES} ok />
      </div>
      <div className="rounded-md border border-[#222D3D] bg-[#141A24] p-6">
        <h3 className="text-sm font-semibold text-slate-300 mb-5">Never collected</h3>
        <List items={NO} />
      </div>
    </div>
  </section>
);
